export default __webpack_public_path__ + "static/media/onboarding_girl_mobile.40b3fc75.png";